var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("select_item_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('select_item_page.form_desc'))
    }
  }), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading ? _c('div', [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l(_vm.options, function (option, idx) {
    return _c('div', {
      key: idx,
      staticClass: "col-12 col-sm-6 px-2"
    }, [_c('SharedRadio', {
      attrs: {
        "id": "proxy-".concat(idx),
        "value": option.value,
        "name": "proxy"
      },
      model: {
        value: _vm.proxy,
        callback: function callback($$v) {
          _vm.proxy = $$v;
        },
        expression: "proxy"
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")])], 1);
  }), 0)]), _c('small', [_vm._v(_vm._s(_vm.getModuleConfig("select_item_page.form_memo")))])]) : _vm._e()], 1), _vm.getModuleConfig('select_item_page.button_text') || _vm.getModuleConfig('select_item_page.cancel_button_text') ? _c('div', {
    staticClass: "p-3 fixed-bottom bg-white footer"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'LiffCouponListSelectBranch'
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.getModuleConfig("select_item_page.button_text")))]), _c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    attrs: {
      "variant": "outline-dark"
    }
  }, [_vm._v(_vm._s(_vm.getModuleConfig("select_item_page.cancel_button_text")))])], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }